// Imported first in main.js: adopts the admin preview session before Echo, axios and the router read the token.
import { readAndClearAdminPreview, applyAdminPreview } from "./adminPreviewHandoff";

try {
	applyAdminPreview(readAndClearAdminPreview());
} catch (e) {
	// Never block the app start: without a handoff the page opens with the current session.
}
